import { Flex } from '@banhala/ui-kit';
import type { TwoLineMessageProps } from './types';
import { isNotNil } from '../../../../utils';
import { HTMLText } from '../../../HTMLText';

export const TwoLineMessage = ({ entity }: TwoLineMessageProps) => {
  if (!entity) {
    return null;
  }

  const { title, description } = entity[0].item;

  return (
    <Flex.Center padding={{ vertical: 64, horizontal: 16 }}>
      <Flex.Column alignItems="center">
        {title && (
          <HTMLText type="subtitle1" color="content_primary">
            {title}
          </HTMLText>
        )}
        {isNotNil(description) && (
          <HTMLText type="body2" color="content_tertiary">
            {description}
          </HTMLText>
        )}
      </Flex.Column>
    </Flex.Center>
  );
};
